// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_ZE","pageSubTitle":"e__E"};